























import { Vue, Component, Watch } from 'vue-property-decorator'
import gql from 'graphql-tag'
import { State } from 'vuex-class'

import AppSnack from '@/components/AppSnack.vue'
import AppDrawer from '@/components/AppDrawer.vue'
import AppNav from '@/components/AppNav.vue'
import { dispatchSignIn } from '@/store/dispatches'
import { User } from '@/interfaces/user'
import { AuditStatus } from '@/interfaces/status'
import { showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'

@Component({
  components: {
    AppSnack,
    AppDrawer,
    AppNav
  }
})
export default class App extends Vue {
  windowSize = {
    w: 0,
    h: 0
  };

  hideNav = true;

  ready = false;

  @State((state) => state.user.me) me!: User;

  @Watch('$route', { immediate: true })
  onRouteChanged (to: any) {
    if (to.name === 'SignIn' || !to.name) {
      this.ifMenu = false
      this.hideNav = true
    } else {
      this.ifMenu = true
      this.hideNav = false
    }
  }

  ifMenu = false;

  mounted () {
    const token = localStorage.getItem(
      process.env.VUE_APP_LOCAL_STORAGE_KEY as string
    )
    this.onResize()
    // 页面刷新vuex数据丢失，在页面刷新前，保存数据到本地
    if (token) {
      this.getMe()
    } else {
      this.$router.replace({ name: 'SignIn' })
      this.ready = true
    }
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }

  // 获取登录用户信息
  async getMe () {
    try {
      const result = await this.$apollo.query({
        query: gql`
          query {
            me {
              createdAt
              dealer {
                id
                ifStoreOpening
                status
              }
              email
              id
              phone
              role
              updatedAt
              username
            }
          }
        `
      })
      if (result.errors) {
        localStorage.removeItem(
          process.env.VUE_APP_LOCAL_STORAGE_KEY as string
        )
        if (this.$route.name !== 'SignIn') {
          this.$router.replace({ name: 'SignIn' })
        }
      } else {
        const me = result.data.me
        if (me.role === 'DEALER') {
          if (me.dealer?.status !== AuditStatus.APPROVED) {
            showNotification({
              msg: '审核未通过',
              type: SnackType.Error
            })
            this.$router.replace({ name: 'SignIn' })
            return false
          }
        }
        dispatchSignIn(result.data.me)
        sessionStorage.setItem('role', result.data.me.role)
        this.ready = true
      }
    } catch (e) {
      localStorage.removeItem(process.env.VUE_APP_LOCAL_STORAGE_KEY as string)
    }
  }
}
